/**
 * Characters the server refuses in a default font family, because they could
 * end the CSS declaration or the style attribute it is written into, plus
 * invisible control and formatting characters. Mirrors FONT_FAMILY in
 * UpdateEditorDefaultTemplateSettingsRequest.
 */
const REFUSED = /[;:{}<>=\\\p{Cc}\p{Cf}]/u;

/**
 * A font's CSS family list as the Template defaults form may save it: double
 * quotes become single quotes, and a list the server would refuse is null.
 */
export const usableFontStyle = (style: string | undefined): string | null => {
    if (!style) {
        return null;
    }

    const requoted = style.replace(/"/g, "'");

    return REFUSED.test(requoted) ? null : requoted;
};
